import { render, staticRenderFns } from "./gNav.vue?vue&type=template&id=b1b421f8&scoped=true&"
import script from "./gNav.vue?vue&type=script&lang=js&"
export * from "./gNav.vue?vue&type=script&lang=js&"
import style0 from "./gNav.vue?vue&type=style&index=0&id=b1b421f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b421f8",
  null
  
)

export default component.exports